import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { skillsService } from "../../../services/skillsService";
import { AdminLayout } from "../../layout/AdminLayout";
import { toast } from "react-toastify";

export const SkillForm = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNew, setIsNew] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id && id !== "new") {
      setIsNew(false);
      loadSkill(id);
    }
  }, [id]);

  const loadSkill = async (skillId) => {
    try {
      const data = await skillsService.getById(skillId);
      setName(data.name);
      setDescription(data.description || "");
    } catch (error) {
      toast.error("Failed to load skill");
      navigate("/admin/skills");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = { name, description };

      if (isNew) {
        await skillsService.create(formData);
        toast.success("Skill created");
      } else {
        await skillsService.update(id, formData);
        toast.success("Skill updated");
      }

      navigate("/admin/skills");
    } catch (error) {
      toast.error("Failed to save skill");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="p-6">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            {isNew ? "Add Skill" : "Edit Skill"}
          </h1>

          <div className="bg-white rounded-lg shadow p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Skill Name *
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="e.g., React.js"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="4"
                  placeholder="Skill description"
                />
              </div>

              <div className="flex gap-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-medium py-2 rounded-lg transition"
                >
                  {loading ? "Saving..." : "Save Skill"}
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/admin/skills")}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium py-2 rounded-lg transition"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};
